import { render, staticRenderFns } from "./Ldw931.vue?vue&type=template&id=5ff88012&scoped=true"
import script from "./Ldw931.vue?vue&type=script&lang=js"
export * from "./Ldw931.vue?vue&type=script&lang=js"
import style0 from "./Ldw931.vue?vue&type=style&index=0&id=5ff88012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff88012",
  null
  
)

export default component.exports